import { ThunkAction } from 'redux-thunk';
import { getBraintreeClientToken as getBraintreeClientTokenApi } from '../../api/braintreeClient';
import { PAYMENT_METHODS } from '../../constants';
import { getCurrency } from '../../selectors/event';
import { isExpressCheckoutEnabled } from '../../selectors/expressCheckoutConditions';
import { getAvailablePaymentMethods } from '../../selectors/order/typedOrderSelectors';
import { CheckoutState } from '../../state';

const braintreeInstruments = new Set([
    PAYMENT_METHODS.NONCE_BRAINTREE,
    PAYMENT_METHODS.APPLE_PAY,
    PAYMENT_METHODS.GOOGLE_PAY,
]);

export const getBraintreeClientToken =
    (): ThunkAction<
        ReturnType<typeof getBraintreeClientTokenApi>,
        CheckoutState,
        void
    > =>
    async (_, getState) => {
        const state = getState();
        const {
            app: {
                featureFlags: { enableNonceBraintreePayments },
            },
        } = state;

        const hasBraintreeInstruments =
            getAvailablePaymentMethods(state)
                ?.find((method) => method.type === 'eventbrite')
                ?.instrumentTypes.find((instrument) =>
                    braintreeInstruments.has(instrument.type),
                ) || isExpressCheckoutEnabled(getState());

        return !enableNonceBraintreePayments || !hasBraintreeInstruments
            ? {
                  // Braintree is not a payment method. No need for a client token.
                  response: {
                      client_token: undefined,
                  },
                  headers: {},
              }
            : getBraintreeClientTokenApi(getCurrency(state));
    };
